"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _useVideoModal = require("b2b-components/hooks/useVideoModal");
var _useVideoThumbnail = require("b2b-components/hooks/useVideoThumbnail");
var _TextMedia = require("../TextMedia");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var WithContainer = function WithContainer(props) {
  var videoUrl = props.videoUrl;
  var videoThumbnailUrl = (0, _useVideoThumbnail.useVideoThumbnail)(videoUrl);
  var injectedProps = _objectSpread(_objectSpread({}, (0, _useVideoModal.useVideoModal)()), {}, {
    videoThumbnailUrl: videoThumbnailUrl
  });
  return /*#__PURE__*/_react["default"].createElement(_TextMedia.TextMedia, (0, _extends2["default"])({}, props, injectedProps));
};
exports.WithContainer = WithContainer;